import {DocumentType} from './document-type.model';

export class Document {
    readonly _id: string;
    readonly type: DocumentType;
    readonly fileIds: string[];
    readonly source: string;
    readonly file_name: string;

    constructor(type: DocumentType, fileIds: string[], fileUrl?: string, fileName?: string) {
        this.type = type;
        this.fileIds = fileIds;
        this.source = fileUrl;
        this.file_name = fileName;
    }
}
